import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {FormDataUpload, NestApiProvider} from "../../nest-api";
import {
  RequestCreateAndUpdateJobGradeDto, RequestDeleteJobGradeStatusDto,
  ResponseCreateJobGradeDto, ResponseDeleteJobGradeStatusDto,
  ResponseGetJobGradeDto, ResponseUpdateJobGradeDto
} from "../dto/jobGrade.dto";

@Injectable()
export class JobGradeApi {

  private service: string = 'attendance';
  private model: string = 'jobGrade';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public downloadTemplate(): Observable<any> {
    const method: string = 'GET';
    const func: string = 'downloadTemplate';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, func, params, body);
  }

  public uploadJobGrade(file: File): Observable<any> {
    const method: string = 'POST';
    const func: string = 'uploadJobGrade';
    const params: FormDataUpload[] = [];
    params.push({name: 'file', value: file});
    const urlParams: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestUpload(method, url, params);
  }

  public getJobGrade(): Observable<ResponseGetJobGradeDto> {
    const method: string = 'GET';
    const func: string = 'getJobGrade';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseGetJobGradeDto>(method, url, params, urlParams, body);
  }

  public createJobGrade(data:RequestCreateAndUpdateJobGradeDto): Observable<ResponseCreateJobGradeDto> {
    const method: string = 'POST';
    const func: string = 'createJobGrade';
    const params: RequestCreateAndUpdateJobGradeDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseCreateJobGradeDto>(method, url, params, urlParams, body);
  }

  public updateJobGrade(data: RequestCreateAndUpdateJobGradeDto):Observable<ResponseUpdateJobGradeDto> {
    const method: string = 'POST';
    const func: string = 'updateJobGrade';
    const params: RequestCreateAndUpdateJobGradeDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseUpdateJobGradeDto>(method, url, params, urlParams, body);
  }

  public deleteJobgradestatus(data: RequestDeleteJobGradeStatusDto):Observable<ResponseDeleteJobGradeStatusDto>{
    const method: string = 'POST';
    const func: string = 'deleteJobgradestatus';
    const params: RequestDeleteJobGradeStatusDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseDeleteJobGradeStatusDto>(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/job-grade.api.ts